import { BankingInformationModel, PropertyMappingEntityEnum } from '../models';
import { DefaultPropertiesBuilder } from './default-properties-builder';
import { Property, PropertyTypeEnum } from './types';

export type BankingInformationPropertyKey = keyof BankingInformationModel;

export const getBankingInformationDefaultPropertiesDefinition = (
  entity: PropertyMappingEntityEnum,
): Record<BankingInformationPropertyKey, Property<PropertyTypeEnum>> =>
  new DefaultPropertiesBuilder<BankingInformationModel>(entity)
    .addProperty('iban', PropertyTypeEnum.text, {
      alwaysRequired: false,
      label: 'IBAN',
    })
    .addProperty('bic', PropertyTypeEnum.text, {
      alwaysRequired: false,
      label: 'BIC',
    })
    .getDefinition();
